import type { WorkPeriodNode } from '../types.graphql'
import { TextAndAction } from './TextAndAction'
import { GenerationTraceTooltip } from './generation-trace-tooltip'
import { formatPartOfDay } from './part-of-day'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { SalaryDayNode } from '@/modules/activities'
import { useEditSalaryDay } from './use-edit-salary-day'

export const SalaryDayButton: React.FC<{
  workPeriod?: Pick<WorkPeriodNode, 'id'>
  /** Award the salary day to the rest after a shift instead of to the shift. */
  restPeriod?: { id: string; nights?: number }
  salaryDay?:
    | (Pick<SalaryDayNode, 'partOfDay' | 'salaryCode'> & {
        generationTrace?: unknown
      })
    | null
  userId: string
  canEdit?: boolean
  border?: boolean
  restrictWidth?: boolean
  onChange?: () => void
}> = ({
  workPeriod,
  restPeriod,
  salaryDay,
  userId,
  canEdit,
  border,
  restrictWidth,
  onChange,
}) => {
  const translations = useTranslate({
    salaryDay: 'common.salary-day',
  })
  const editSalaryDay = useEditSalaryDay(userId, onChange)

  return (
    <TextAndAction
      text={translations.salaryDay}
      info={<GenerationTraceTooltip trace={salaryDay?.generationTrace} />}
      actionText={
        salaryDay && salaryDay.partOfDay
          ? `${formatPartOfDay(salaryDay.partOfDay ?? 0)} ${
              salaryDay.salaryCode?.name ?? ''
            }`
          : undefined
      }
      border={border}
      onClick={
        canEdit
          ? () =>
              void editSalaryDay({
                workPeriodId: workPeriod?.id ?? null,
                restPeriodId: restPeriod?.id ?? null,
                maxPartOfDay: restPeriod?.nights ?? 1,
                salaryDay,
              })
          : () => {}
      }
      restrictWidth={restrictWidth}
      disabled={!canEdit}
    />
  )
}
